import React, {useState, useEffect} from 'react'
import { createTheme, ThemeProvider } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';

const useStyles = createTheme((theme) => ({
  root: {
    paddingLeft: '38px',
    '& > *': {
      margin: theme.spacing(1),
      width: '55ch',
      paddingLeft: '32px',
    },
  },
}));

export default function TextFields_Outlined_Long({id, requried, label, triggerUpdateInParent, validationText, required, paddingLeft, extraClasses, valueInField, classesToAdd}) {
  //const classes = useStyles();
  const [requiredError, setRequiredError] = useState(false);
  const [helperText, setHelperText] = useState('');

  // This will turn the help text on when something such as a validation
  // fails in the parent component
  useEffect(() => {
    setHelperText(validationText)
  }, [validationText]);

  const handleChange = (event) => {
    if (triggerUpdateInParent) triggerUpdateInParent(event.target.id, event.target.value)
    if (required && event.target.value == ""){
      setRequiredError(true)
      setHelperText('Required field.')
    }
    else {
      setRequiredError(false)
      setHelperText('')
    }

    // Check to see if the validation failed in the parent component and
    // wants to pass some text into here
    //setHelperText(validationText)
    //console.log("FAILED VALIDATIONT TEXT: "+ validationText)
  };

  return (
    
    <ThemeProvider theme={useStyles}>
      {required ? <span className="required-field">*</span> : <span className="unrequired-field">*</span>}
      <TextField 
        //className={`${classes.root} long-input-fix ${classesToAdd}`} 
        className={`long-input-fix ${classesToAdd}`} 
        id={id} 
        defaultValue={valueInField}
        label={label} 
        variant="outlined" 
        helperText={helperText} 
        onFocusOut={() => setRequiredError(true)} onChange={handleChange}
        error={requiredError}
        onKeyUp={handleChange}
      />
      </ThemeProvider>
    
  );
  {/*<form className={classes.root} noValidate autoComplete="off">*/}
  {/*</form>*/}
}